import React, { useMemo } from 'react'

import { DragAndDropStatusProps, IDragAndDropGridProps, IDragAndDropResultProps } from './_types'
import { DragAndDropWrapper } from './DragAndDropWrapper'
import { chunkItems } from './util/chunkItems'

export function DragAndDropGrid<ItemType extends DragAndDropStatusProps>({
  items,
  itemsPerLine,
  direction,
  renderItem,
  onDragEnd,
}: IDragAndDropGridProps<ItemType>) {
  const chunks = useMemo(
    () => chunkItems(itemsPerLine, items),
    [items, itemsPerLine],
  )

  const handleDragEnd = ({ source, destination }: IDragAndDropResultProps): void => {
    if (destination) {
      const { index: sourceIndex } = source
      const { index: destinationIndex } = destination

      if (destinationIndex === undefined) return

      onDragEnd(sourceIndex, destinationIndex)
    }
  }

  return (
    <DragAndDropWrapper
      chunks={chunks}
      direction={direction}
      render={renderItem}
      onDragEnd={handleDragEnd}
      itemsPerLine={itemsPerLine}
    />
  )
}
